import {Locales} from '@netx/core-next/locales';
import {
	UploadActionLabel,
	UploadMessage,
	UploadStatusItemStatusLabel,
	UploadLabel,
} from '@netx/core-upload-next/locales';
import {UploadStatusAssetItemStatus} from './constants';

export const UploadAssetLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.upload'),
}));

export const UploadAssetItemStatusLabel = Locales((i18n) => ({
	...UploadStatusItemStatusLabel,
	[UploadStatusAssetItemStatus.COLLISION_REJECTION]: i18n('i18n.duplicate'),
	completed: i18n('i18n.imported'),
	[UploadStatusAssetItemStatus.DUPLICATE]: i18n('i18n.duplicate'),
	error: i18n('i18n.error'),
	[UploadStatusAssetItemStatus.IMPORTING]: i18n('i18n.importing'),
	missing: i18n('i18n.missing'),
	paused: i18n('i18n.paused'),
	recoverable_error: i18n('i18n.error'),
}));

export const UploadAssetConfirmation = Locales((i18n) => ({
	CONFIRM_DISCARD: i18n('i18n.confirmDiscardChanges'),
}));

export const UploadAssetMessage = Locales((i18n) => ({
	...UploadMessage,
	UPLOAD_STARTED_GOTO: i18n('i18n.uploadStartedClickProgress'),
	IMPORT_FAILED: ({fileName}: {fileName: string}) =>
		i18n('i18n.fileImportFailed', {file: fileName}),
	IMPORT_SUCCESS: ({fileName}: {fileName: string}) =>
		i18n('i18n.fileImportedSuccessfully', {file: fileName}),
}));

export const UploadBuilderLabel = Locales((i18n) => ({
	...UploadLabel,
	ATTRIBUTES: i18n('i18n.attributes'),
	LOCATION: i18n('i18n.location'),
	MANDATORY: i18n('i18n.mandatory'),
	NOT_SELECTED: i18n('i18n.notSelected'),
	OPTIONAL: i18n('i18n.optional'),
	IMPORTING: i18n('i18n.importing'),
}));

export const UploadBuilderTitle = Locales((i18n) => ({
	UPLOADS: i18n('i18n.uploads'),
	UPLOAD: i18n('i18n.upload'),
	NEW_UPLOAD: i18n('i18n.newUpload'),
	EDIT_ATTRIBUTES: i18n('i18n.editAttributes'),
}));

export const UploadAssetWarning = Locales((i18n) => ({
	COLLISION_REJECTED: ({fileName}: {fileName: string}) =>
		i18n('i18n.importCollisionRejectWarning', {file: fileName}),
	DUPLICATE_DETECTED: ({fileName}: {fileName: string}) =>
		i18n('i18n.importFileDuplicateWarning', {file: fileName}),
	FILE_DOES_NOT_MATCH: i18n('i18n.uploadAssetReselectMismatch'),
	MISSING_FILES: (count: number) =>
		i18n('i18n.uploadAssetMissingFiles', {count}),
}));

export const UploadAssetActionLabel = Locales((i18n) => ({
	...UploadActionLabel,
	BACK: i18n('i18n.back'),
	CANCEL: i18n('i18n.cancel'),
	DUPLICATE: i18n('i18n.duplicate'),
	GOTO_ASSET: i18n('i18n.viewAsset'),
	GOTO_FOLDER: i18n('i18n.gotoCategory'),
	GOTO_STATUS: i18n('i18n.gotoStatus'),
	NEW_UPLOAD: i18n('i18n.newUpload'),
	NEXT: i18n('i18n.next'),
	REIMPORT: i18n('i18n.reimport'),
	REMOVE: i18n('i18n.remove'),
	SELECT_CATEGORY: i18n('i18n.selectCategory'),
	VIEW_DUPLICATE: i18n('i18n.viewDuplicate'),
}));

export const UploadAssetProcessLabel = Locales((i18n) => ({
	ImportingTask: i18n('i18n.importing'),
	VisualDescriptorTask: i18n('i18n.performingTaskVisualDescriptor'),
	ImageProxiesTask: i18n('i18n.performingTaskImageProxies'),
	AudioTask: i18n('i18n.performingTaskAudio'),
	FFFViewTask: i18n('i18n.performingTaskFFFView'),
	INDDPageTask: i18n('i18n.performingTaskINDDPage'),
	IWorkPageTask: i18n('i18n.performingTaskIWorkPage'),
	KeyframesTask: i18n('i18n.performingTaskKeyframes'),
	MetadataTask: i18n('i18n.performingTaskMetadata'),
	OfficePageTask: i18n('i18n.performingTaskOfficePage'),
	PDFPageTask: i18n('i18n.performingTaskPDFPage'),
	PostImportTask: i18n('i18n.performingTaskPostImport'),
	PreviewTask: i18n('i18n.performingTaskPreview'),
	RelatedAssetTask: i18n('i18n.performingTaskRelatedAssets'),
	SWFTask: i18n('i18n.performingTaskSWF'),
	ThumbnailTask: i18n('i18n.performingTaskThumbnail'),
	VideoPreviewTask: i18n('i18n.performingTaskVideoPeview'),
	WatermarkTask: i18n('i18n.performingTaskWatermark'),
	ZoomTask: i18n('i18n.performingTaskZoom'),
	ZoomTileTask: i18n('i18n.performingTaskZoomTiles'),
}));

export const UploadAssetReimportTitle = Locales((i18n) => ({
	REIMPORT: i18n('i18n.reimport'),
}));

export const UploadAssetReimportMessage = Locales((i18n) => ({
	ALREADY_UPDATING: i18n('i18n.fileInProgress'),
	REIMPORTED: i18n('i18n.reimportSuccessful'),
	REIMPORTING: i18n('i18n.reimportingAsset'),
}));
